// Librerias
import React from 'react'
let PropTypes = React.PropTypes
import { AutoSizer, Table, Column } from 'react-virtualized'
import { obtenerVerificador } from '../shared/ValidadorRUN.js'
// Styles
import * as css from '../admin/MantenedorPersonal/tablaPersonal.css'
import classNames from 'classnames/bind'
let cx = classNames.bind(css)

export class TablaUsuariosPendientes extends React.Component {
    renderLink = (cellData) => {
    return <a className="btn btn-xs btn-primary" href={`/nomina/${cellData}`} target="_blank">Nomina</a>
    }

    render(){
        return (
            <div style={{height: '70%'}}>
                <AutoSizer>
                    {({ height, width }) =>
                        <Table
                            // general
                            height={height}
                            width={width}
                            // headers
                            headerHeight={30}
                            headerClassName={css.headerColumn}
                            // rows
                            rowCount={this.props.usuariosPendientes.length}
                            rowGetter={({index})=> this.props.usuariosPendientes[index]}
                            rowHeight={40}
                            rowClassName={({index})=> index<0? css.headerRow : ((index%2===0)? css.evenRow : css.oddRow)}
                        >
                            <Column
                                dataKey='#'
                                label={'#'}
                                disableSort={true}
                                cellRenderer={({rowIndex}) => rowIndex+1}
                                width={25}
                            />
                            <Column
                                dataKey='RUN'
                                label={'RUN'}
                                cellRenderer={({ dataKey, rowData }) =>
                                   <div>
                                        <p style={{margin: 0}}>{rowData[dataKey]}-{obtenerVerificador(rowData[dataKey])}</p>
                                   </div>
                                }
                                width={90}
                            />
                            <Column
                                dataKey='fechaProgramada'
                                label={'FECHA INVENTARIO'}
                                cellRenderer={({ dataKey, rowData }) => rowData[dataKey]}
                                width={190}
                            />
                            <Column
                                dataKey='nombreCorto'
                                label={'CLIENTE'}
                                cellRenderer={({ dataKey, rowData }) => rowData[dataKey]}
                                width={90}
                            />
                            <Column
                                dataKey='numero'
                                label={'CECO'}
                                cellRenderer={({ dataKey, rowData }) => rowData[dataKey]}
                                width={90}
                            />
                            <Column
                                dataKey='nombre'
                                label={'LOCAL'}
                                cellRenderer={({ dataKey, rowData }) => rowData[dataKey]}
                                width={190}
                            />
                            <Column
                                dataKey='region'
                                label={'REGION'}
                                cellRenderer={({ dataKey, rowData }) => rowData[dataKey]}
                                width={150}
                            />
                            <Column
                                dataKey='ciudad'
                                label={'CIUDAD'}
                                cellRenderer={({ dataKey, rowData }) => rowData[dataKey]}
                                width={150}
                            />
                            <Column
                                dataKey='idNomina'
                                label={'NOMINA'}
                                cellRenderer={({ dataKey, rowData }) =>
                                    this.renderLink(rowData[dataKey])
                                }
                                width={70}
                            />
                        </Table>
                    }
                </AutoSizer>
            </div>
        )
    }
}
TablaUsuariosPendientes.propTypes = {
    usuariosPendientes: PropTypes.arrayOf(PropTypes.object).isRequired
}


// WEBPACK FOOTER //
// ./frontEnd/usuariosPendientes/tablaUsuariosPendientes.jsx